import React, {useContext, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../contexts/AuthContext'
import { Loading } from './loading'
import RootStore from '../../store/RootStore'

export const SignInRedirectCallback = () => {
  const { authStore } = RootStore
  const { signinRedirectCallback } = useContext(AuthContext)

  const navigate = useNavigate()

  useEffect(() => {
    async function handleCallback() {
      const urlParams = new URLSearchParams(window.location.search)
      const hasState = urlParams.has('state')
      const hasCode = urlParams.has('code')
      if (hasState && hasCode) {
        const callBackReturnValue = await signinRedirectCallback()
        if (callBackReturnValue !== null) {
          const {user, returnUrl} = callBackReturnValue
          await authStore.setUserSSO(user)
          navigate(returnUrl)
        }
      }
    }

    handleCallback()
  }, [authStore, navigate, signinRedirectCallback])

  return <Loading />
}
